import {
  PATIENT_GET_HEALTH_RECORD,
  PATIENT_GET_DOCUMENT,
  PATIENT_CLEAR
} from '../actions/types';

const initialState = {
  data: [],
  detail: {},
  dataHealthRecords: [],
  dataDocumentFiles: []
};

export default function PatientReducer(state = initialState, action = {
  type: undefined
}) {
  switch (action.type) {
    case PATIENT_GET_HEALTH_RECORD:
    case PATIENT_GET_DOCUMENT:
      return { ...state, ...action.playload };
    case PATIENT_CLEAR:
      return {
        ...state,
        dataHealthRecords: [],
        dataDocumentFiles: [],
        status: undefined,
        message: undefined
      };
    default:
      return { ...state };
  }
}
